import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { SL_WEB_KBYG_GREEN } from 'common/treatments';
import { useTreatments } from 'utils/treatments';

// Cookie names
export const KBYG_GREEN_COOKIE = 'sl_kbyg_web_green';

// Cookie expiration in days
const COOKIE_EXPIRATION_DAYS = 3;

/**
 * Hook to manage the green deployment cookie based on treatment value
 * This should be called on each page load to ensure the cookie matches treatment status
 * If cookie state changes, the page will reload to apply the new state
 * @returns boolean indicating if green deployment is active
 */
const useGreenDeploy = (): boolean => {
  const treatments = useTreatments();
  const [isGreenDeploy, setIsGreenDeploy] = useState(false);

  useEffect(() => {
    // Skip cookie operations during SSR
    if (typeof window === 'undefined') return;

    // Handle KBYG Green treatment cookie
    const kbygGreenTreatment = treatments[SL_WEB_KBYG_GREEN];
    const cookieExists = !!Cookies.get(KBYG_GREEN_COOKIE);

    if (kbygGreenTreatment === 'on') {
      // Treatment is on
      if (!cookieExists) {
        // No cookie exists, set it and reload the page
        Cookies.set(KBYG_GREEN_COOKIE, 'on', { expires: COOKIE_EXPIRATION_DAYS });
        window.location.reload();
      }
      // If cookie exists, do nothing
      setIsGreenDeploy(true);
    } else {
      // Treatment is off or unknown
      if (cookieExists) {
        // Cookie exists but shouldn't, remove it and reload the page
        Cookies.remove(KBYG_GREEN_COOKIE);
        window.location.reload();
      }
      // If no cookie exists, do nothing
      setIsGreenDeploy(false);
    }
  }, [treatments]);

  return isGreenDeploy;
};

export default useGreenDeploy;
